var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-logo-wrap pointer",on:{"click":function($event){return _vm.goTo2('spaces')}}},[_c('img',{attrs:{"src":require("assets/logo_icon.png")}}),_c('img',{attrs:{"src":require("assets/logo_text.png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }